import React, { Component } from "react";

import axios from "axios";
import isEmpty from "lodash.isempty";

import queryStringUtils from "utils/query-string";
import NonSuperuser from "page/NonSuperuser";
import Superuser from "page/Superuser";
import Notification from "components/Notification";
import InfoBox from "components/InfoBox";

class App extends Component {
  state = {
    fetchConfirmData: {
      loading: false,
      data: {},
      error: null,
      knownError: false
    },
    postConfirmData: {
      loading: false,
      success: false,
      error: null
    }
  };

  constructor(props) {
    super(props);

    this.queryParams = queryStringUtils.parse(window.location.search);
    const { user_id } = this.queryParams;
    const url = this.isSuperuser()
      ? `/superuser/users/${user_id}/confirmation`
      : `/resource/users/${user_id}/confirmation`;

    this.apiRequest = axios.create({
      baseURL: `${process.env.REACT_APP_API_BASE_URL}${url}`,
      headers: {
        Accept: "application/json"
      }
    });
  }

  updateFetchConfirmDataState(state = {}) {
    this.setState({
      fetchConfirmData: {
        ...this.state.fetchConfirmData,
        ...state
      }
    });
  }

  updatePostConfirmDataState(state = {}) {
    this.setState({
      postConfirmData: {
        ...this.state.postConfirmData,
        ...state
      }
    });
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    this.updateFetchConfirmDataState({ loading: true });

    return this.apiRequest({ method: "GET", params: this.queryParams })
      .then(({ data }) => {
        this.updateFetchConfirmDataState({ data, loading: false });
      })
      .catch(error => {
        if (error.response && (error.response.status === 404 || error.response.status === 422)) {
          this.updateFetchConfirmDataState({ knownError: true, loading: false });
        } else {
          this.updateFetchConfirmDataState({ error, loading: false });
        }
      });
  }

  postData = data => {
    this.updatePostConfirmDataState({ loading: true });
    return this.apiRequest({ method: "POST", data })
      .then(({ data }) => {
        this.updatePostConfirmDataState({ success: true, loading: false, ...data });
      })
      .catch(error => {
        this.updatePostConfirmDataState({ error, loading: false });
      });
  };

  isSuperuser() {
    return this.queryParams.role_slug === "superuser";
  }

  renderPostPage({ error, loading, success, company }) {
    if (error) {
      console.log({ error });
    }

    if (loading) {
      return "Loading...";
    }

    if (success) {
      const url =
        this.queryParams.role_slug === "superuser"
          ? process.env.REACT_APP_SUPERUSER_PANEL_URL
          : `${process.env.REACT_APP_ADMIN_PANEL_URL}/${company.url}/login`;

      return (
        <InfoBox
          message={["Your account have been confirm, Click ", <a href={url}>here</a>, " to login."]}
          infoClassName="is-success"
        />
      );
    }
  }

  renderFormPage({ knownError, data, loading }) {
    if (knownError) {
      return (
        <InfoBox
          message="Unable to confirm your account, possible token had expired or missing parameters."
          infoClassName="is-warning"
        />
      );
    }

    if (loading || isEmpty(data)) {
      return "FETCH Loading...";
    }

    const props = { data, postData: this.postData };
    return (
      <div className="box" style={{ padding: "3rem" }}>
        {this.isSuperuser() ? <Superuser {...props} /> : <NonSuperuser {...props} />}
      </div>
    );
  }

  render() {
    const { fetchConfirmData, postConfirmData } = this.state;

    const notiProps = {
      flag: (fetchConfirmData.error && !fetchConfirmData.knownError) || postConfirmData.error,
      meta: {
        infoClassName: "is-danger",
        message:
          (fetchConfirmData.error && !fetchConfirmData.knownError && fetchConfirmData.error.message) ||
          (postConfirmData.error && postConfirmData.error.message)
      }
    };

    return (
      <section className="hero is-info is-fullheight">
        <div className="hero-body">
          <section className="container" style={{ maxWidth: "420px" }}>
            <Notification {...notiProps} />
            {postConfirmData.error || postConfirmData.loading || postConfirmData.success
              ? this.renderPostPage(postConfirmData)
              : this.renderFormPage(fetchConfirmData)}
          </section>
        </div>
      </section>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js